<template>
    <div class="consultar-cartas-proposta">
        <g-card
        class="card-form-consCartProp"
        margem="20px"
        :expansivel="true"
        :comecaFechado="false"
        >
            <template #cabecalho>
                <div class="header-filtros">
                    <div class="titulo-filtros-cabecalho"> Consultar Cartas-Proposta</div>
                    <div class="header-icons">
                        <g-button
                        class="trash-box"
                        tipo="cinza"
                        altura="35px"
                        largura="45px"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                        @click="limpar"
                        />

                        <g-button
                        class="buscar-button-header-filtro"
                        largura="150px"
                        icone="icone_lupa.svg"
                        negritoTexto
                        tamanhoIcone="15px"
                        tamanhoTexto="15px"
                        altura="35px"
                        gap="10px"
                        :sombreado="false"
                        @click="Grid()"
                        >
                            BUSCAR
                        </g-button>
                    </div>
                </div>
            </template>

            <g-form>
                <div class="consCartProp-conteudo espacamento-filtros">

                    <div class="filtro-unidade">
                        <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
                        <PDropDown
                        class="unidade-input input-label unidade"
                        placeholder="TODAS"
                        :options="UnidadeArray"
                        optionLabel="nome"
                        optionValue="id"
                        v-model="objFiltros.UnidadeId"
                        />
                    </div>

                    <div class="filtro-cliente">
                        <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
                        <div class="cliente-checkbox input-label">
                            <!-- <PDropDown
                            class="cliente-input"
                            placeholder="Selecione"
                            :filter="true"
                            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
                            :options="ClienteArray"
                            optionLabel="nomeFantasia"
                            optionValue="id"
                            @filter="buscarClientes($event.value)"
                            emptyMessage="Pesquise o cliente desejado"
                            v-model="objFiltros.ClienteId"
                            >
                                <template #option="slotProps">
                                    <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
                                </template>
                            </PDropDown> -->
                            <cliente-dropdown 
                                class="cliente-input"
                                v-model="objFiltros.ClienteId"
                                :empresaId="objFiltros.UnidadeId"
                                :representanteId="this.$store.state.representanteSelecionadoId"
                            />
                            <div class="consultar-dados">
                                <PCheckBox
                                    id="consultar-dados"
                                    value="consultar-dados"
                                    class="checkbox-consultar-dados"
                                    v-model="objFiltros.ConsultarDadosClienteAgrupador"
                                    ></PCheckBox>
                                <label class="label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                            </div>
                        </div>
                    </div>

                    <div class="numero-solicitacao">
                        <div class="numero-solicitacao-titulo titulo-conteudo-filtros"> Número da Solicitação </div>
                        <PInputText
                        class="numero-solicitacao-input input-label"
                        placeholder="Insira o Nº da Solicitação"
                        v-model="objFiltros.NumeroSolicitacao"
                        />
                    </div>

                    <div class="numero-cartaProp">
                        <div class="numero-cartaProp-titulo titulo-conteudo-filtros"> Nº da Carta Proposta </div>
                        <PInputText
                        class="numero-cartaProp-input input-label"
                        placeholder="Insira o Nº da Carta Proposta"
                        v-model="objFiltros.NumeroCartaProposta"
                        />
                    </div>

                    <div class="filtro-produto">
                        <div class="produto-titulo titulo-conteudo-filtros"> Produto </div>
                        <PDropDown
                            :options="ProdutoArray"
                            :filterFields="['labelProduto', 'componentes']"
                            optionLabel="labelProduto"
                            optionValue="produtoId"
                            placeholder="Selecione a Referência"
                            v-model="objFiltros.ProdutoId"
                            :filter="true"
                            emptyMessage="Pesquise o produto desejado"
                             @filter="buscarProdutos($event.value)"
                        >
                        <template #option="slotProps">
                                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                            </template>
                        </PDropDown>
                    </div>

                    <div class="produto-novo">
                        <div class="produto-novo-titulo titulo-conteudo-filtros"> Produto Novo </div>

                         <PDropDown
                            :filterFields="['labelProduto']"
                            optionLabel="labelProduto"
                            optionValue="produtoId"
                            placeholder="Selecione a Referência"
                            :options="OrcamentoProdutoArray"
                            v-model="objFiltros.OrcamentoProdutoId"
                            :filter="true"
                            emptyMessage="Pesquise o produto desejado"
                             @filter="buscarProdutoNovo($event.value)"
                        >
                        <template #option="slotProps">
                                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
                            </template>
                        </PDropDown>
                    </div>

                    <div class="filtro-status">
                        <div class="status-titulo titulo-conteudo-filtros"> Status </div>
                        <PDropDown
                        class="status-input input-label"
                        placeholder="Todos"
                        optionLabel="text"
                        optionValue="value"
                        :options="StatusArray"
                        v-model="objFiltros.Status"
                        />
                    </div>

                    <div class="periodo-baixa">
                        <div class="periodo-baixa-titulo titulo-conteudo-filtros"> Período de Baixa </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                class="periodo-baixa-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                v-model="objFiltros.DataInicioBaixa"
                                :dataPassadas="true"
                                :retornaDateTime="true"
                                ></g-date-input>
                            </div>
                            <div class="data-periodo"> à </div>
                            <div class="data-termino">
                                <g-date-input
                                class="periodo-baixa-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                v-model="objFiltros.DataFinalBaixa"
                                :dataPassadas="true"
                                :retornaDateTime="true"
                                ></g-date-input>
                            </div>
                        </div>
                    </div>

                    <div class="periodo-emissao">
                        <div class="periodo-emissao-titulo titulo-conteudo-filtros"> Período de Emissão </div>
                        <div class="input-data">
                            <div class="data-inicio">
                                <g-date-input
                                class="periodo-emissao-inicio-input input-label"
                                placeholderinput="Início"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                v-model="objFiltros.DataInicioEmissao"
                                :dataPassadas="true"
                                :retornaDateTime="true"
                                ></g-date-input>
                            </div>
                            <div class="data-periodo"> à </div>
                            <div class="data-termino">
                                <g-date-input
                                class="periodo-emissao-termino-input input-label"
                                placeholderinput="Término"
                                alturainput = "40px"
                                largurainput = "100%"
                                tamanhobotao = "35px"
                                v-model="objFiltros.DataFinalEmissao"
                                :dataPassadas="true"
                                :retornaDateTime="true"
                                ></g-date-input>
                            </div>
                        </div>
                    </div>



                    <div class="ordenacao">
                        <div class="ordenacao-titulo titulo-conteudo-filtros"> Ordenação </div>
                        <div class="ordenacao-checkboxes input-label">
                            <div class="data-hora">
                                <PCheckBox
                                    id="data-hora"
                                    :binary="true"
                                    class="checkbox-data-hora"
                                    v-model="objFiltros.OrdenarPorDataHora"
                                     @change="objFiltros.OrdenarPorDataHora ? objFiltros.OrdernarPorNumeroCartaProposta = false : objFiltros.OrdenarPorDataHora"></PCheckBox>
                                <label class="label-checkbox" for="data-hora"> Data e Hora da Carta Proposta </label>
                            </div>
                            <div class="numero-carta">
                                <PCheckBox
                                    id="numero-carta"
                                    :binary="true"
                                    class="checkbox-numero-carta"
                                    v-model="objFiltros.OrdernarPorNumeroCartaProposta"
                                    @change="objFiltros.OrdernarPorNumeroCartaProposta ? objFiltros.OrdenarPorDataHora = false : objFiltros.OrdernarPorNumeroCartaProposta"></PCheckBox>
                                <label class="label-checkbox" for="numero-carta"> Número da Carta Proposta </label>
                            </div>
                        </div>
                    </div>

                    <div class="buscar-button-filtro">
                        <g-button
                        class="buscar-button"
                        largura="300px"
                        icone="icone_lupa.svg"
                        negritoTexto
                        tamanhoIcone="15px"
                        tamanhoTexto="15px"
                        altura="35px"
                        gap="10px"
                        :sombreado="false"
                        @click="Grid()"
                        >
                            BUSCAR
                        </g-button>
                    </div>
                </div>
            </g-form>
        </g-card>

        <g-card paddingDefault="0 0em 1em"
        class="card-resultado"
        :temCabecalho="false"
        >
            <div v-if="mostraMensagemVazio" class="card-resultado-consCartProp">
                <img
                    class="icone-global-imagemfundo"
                    src="@/assets/imgs/Ilustracao_erro.svg"
                />
                <div class="texto-padrao-imagemfundo">
                    Verifique os filtros e clique em buscar para exibir os resultados
                </div>
            </div>

            <div v-else-if="!mostraMensagemVazio">
                <g-data-table
                class="datatable-consCartProp"
                altura="auto"
                :numeroBotoesAcao="3"
                TextoVazio="Nenhuma Carta-Proposta encontrada"
                Titulo="Cartas Proposta"
                :colunas="Colunas"
                :Copiaveis="true"
                TextCopiar="Nova versão"
                :Editavel="false"
                :Filtros="Filtro"
                :FiltrosEspecificos = "true"
                :Imprimivel="true"
                :DownloadPDF="true"
                :NumeroLinhas="100"
                :Paginacao="true"
                :valores="CartasPropostaArray"
                :colunaColorida="'statusEnumCCP'"
                :GetStatusColors="'corStatusCartaProposta'"
                v-on:duploClickLinha="RotaCartaPropDet"
                :campoAgrupador="'empresaCliente'"
                :campoExibicaoGrupo="'empresaCliente'"
                :BaixarCartaPropostaBotao="true"
                v-on:CopiaveisClick="NovaVersao"
                v-on:baixarCartaProposta="baixarCartaProposta"
                v-on:clickImprimir="abrirPDF"
                v-on:downloadPDF="baixarPDF"
                TextImprimir="Abrir PDF"
                TextDownload="Baixar PDF"
                >
                </g-data-table>
            </div>
        </g-card>
    </div>


    <div class="popup-baixar-carta">
        <PDialog :showHeader="false" :closable="false" v-model:visible="popupDarBaixa" :modal="true" >
        <div class="conteudo-popup-funcoes"> Desejar dar baixa na Carta-Proposta? </div>
        <div class="popup-baixar-carta">
            <div class="botao-nao">
            <g-button tipo="cinza" largura="100%" negritoTexto @click="FecharPopupBaixarCarta"> NÃO </g-button>
            </div>
            <div class="botao-sim">
            <g-button largura="100%" negritoTexto @click="ContinuarBaixaCarta"> SIM </g-button>
            </div>
        </div>
        </PDialog>
    </div>

    <div class="popup-motivo-baixa-orcamento">
        <PDialog id="popup-motivo-baixa" :closable="false" v-model:visible="popupContinuarBaixarCarta">
            <template #header>
                <div class="titulo-subtitulo-popup-motivo-baixa">
                    <div class="titulo-popup-motivo-baixa"> BAIXA / DISPOSIÇÃO </div>
                    <div class="subtitulo-popup-motivo-baixa"> Descreva sobre o processo de baixa da carta-proposta </div>
                </div>
            </template>
    
            <div class="conteudo-popup-motivo-baixa">
                <div class="motivo">
                    <div class="titulo"> Motivo <strong class="asterisco-obrigatorio">*</strong></div>
                    <PDropDown class="motivo-input input-label" placeholder="Selecione" v-model="motivoBaixa"
                        :options="MotivoBaixaArray" optionLabel="text" optionValue="value" :filter="true">
                    </PDropDown>
                </div>
    
                <div class="concorrente">
                    <div class="titulo"> Concorrente </div>
                    <PDropDown class="concorrente-input input-label" placeholder="Selecione" v-model="concorrenteId"
                        :options="ConcorrenteArray" optionLabel="nomeConcorrente" optionValue="id" :filter="true">
                    </PDropDown>
                </div>

                <div class="observacao">
                    <div class="titulo"> Observação </div>
                    <PTextArea
                    rows="5" cols="40" :autoResize="true"
                    v-model="observacaoBaixa"
                    class="observacao-input input-label"
                    ></PTextArea>
                </div>
            </div>
    
            <div class="botoes-motivo-baixa">
                <g-button tipo="cinza" class="botao-cancelar" largura="200px" textoFontWeight="500"
                    @click="FecharPopupMotivoBaixarCarta">
                    CANCELAR
                </g-button>
                <g-button tipo="amarelo" class="botao-informar" largura="200px" textoFontWeight="500"
                    @click="setMotivoBaixarOrcamento">
                    GRAVAR
                </g-button>
            </div>
        </PDialog>
    </div>

    <div class="popup-motivo-baixa-orcamento">
        <PDialog id="popup-motivo-baixa" :closable="false" v-model:visible="popupNovaVersaoCarta">
            <template #header>
                <div class="titulo-subtitulo-popup-motivo-baixa">
                    <div class="titulo-popup-motivo-baixa"> NOVA VERSÃO </div>
                    <div class="subtitulo-popup-motivo-baixa"> Deseja criar uma nova versão da carta-proposta? </div>
                </div>
            </template>
    
            <div class="botoes-motivo-baixa">
                <g-button tipo="cinza" class="botao-cancelar" largura="200px" textoFontWeight="500"
                    @click="this.popupNovaVersaoCarta = false">
                    NÃO
                </g-button>
                <g-button tipo="amarelo" class="botao-informar" largura="200px" textoFontWeight="500"
                    @click="CreateCartaPropostaVersion">
                    SIM
                </g-button>
            </div>
        </PDialog>
    </div>

 
        <PdfCartaPropostaComComponentes 
            v-if="renderiza && cartaPropostaTipo === 0"
            :cartaPropostaId = "idCartaProposta"
            :nomeClientePersonalizado="inputNomeCliente" 
            :openPdfNewTab="abrePdf"
            :canDownloadPdf="podeBaixarPdf"
            :key="renderizaKey"
        />
        
        
        <PdfCartaPropostaSemComponentes
            v-else-if="renderiza"
            :cartaPropostaId = "idCartaProposta"
            :nomeClientePersonalizado="inputNomeCliente" 
            :openPdfNewTab="abrePdf"
            :canDownloadPdf="podeBaixarPdf"
            :key="renderizaKey + 1"
        />
   
</template>

<script>


import ConsultarCartasProposta from './ConsultarCartasProposta.js'
export default ConsultarCartasProposta
</script>

<style scoped>
.observacao-input {
    text-align: justify;
    height: 100px;
}
.botoes-motivo-baixa {
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
}
.titulo-subtitulo-popup-motivo-baixa {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.titulo-popup-motivo-baixa, .subtitulo-popup-motivo-baixa {
  color:#4F4C4D;
  font-family: 'MontSerrat';
  font-weight: bold;
  text-align: center;
}

.titulo-popup-motivo-baixa { font-size: 19px; margin-bottom: 5px; }
.subtitulo-popup-motivo-baixa { font-size: 16px; }

.conteudo-popup-motivo-baixa { margin-bottom: 1.5rem; }

.popup-baixar-carta {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 2%;
}
.conteudo-popup-funcoes {
  grid-area: 1 / 1 / 2 / 2;
  color: #4E4E4E;
  text-align: center;
  font-weight: 600;
  font-family: 'MontSerrat';
  margin-top: 25px;
  margin-bottom: 15px;
}
.popup-baixar-carta{
  grid-area: 2 / 1 / 3 / 2;
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: 100%;
  grid-column-gap: 5%;
}





.p-dropdown {
    width: 100%;
}

.header-consCartProp {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.consCartProp-titulo {
    color: #4f2c19;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  padding: 5px 0;
}
.label-checkbox {
  color: #838383;
  text-align: left;
  font-family: Montserrat;
  margin-left: 6px;
}
.periodo-baixa-data, .periodo-emissao-data {
  color: #747474;
  font-family: Montserrat;
}

.input-label {
  margin-bottom: 15px;
}
.consultar-dados, .data-hora ,.numero-carta {
  display: flex;
}

.conteudo-popup-edicao {
  text-align: center;
}

.datatable-consCartProp {
    border-radius: 10px;
}


.card-resultado-text {
    color: #4f2c19;
    text-align: center;
    font-family: Montserrat;
    margin-top: 10px;
}
.card-resultado-text-small {
    color: #4F4C4D;
    font-family: Montserrat;
}
.imagem-nenhuma-info {
    margin: 0 auto;
    max-height: 500px;
}



@media (min-width:310px) {

.header-consCartProp {
    display: flex;
}
.consCartProp-titulo {
    font-size: 18px;
    margin: 0;
}
.buscar-button-header {
    display: none;
}

.titulo {
  font-size: 14px;
}
.label-checkbox {
  font-size: 14px;
}
.consCartProp-conteudo {
  display: flex;
  flex-direction: column;
  margin: 20px 20px 0 20px;

}

.cliente-checkbox {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, auto);
  grid-row-gap: 10%;
}

.ordenacao-checkboxes {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 10%;
}

.numero-solicitacao-input, .numero-cartaProp-input, .produto-input, .produto-novo-input, .empresa-input, .unidade-input ,.cliente-input, .status-input {
  width: 100%;
}

.imagem-nenhuma-info {
    height: 8rem;
    width: auto;
}

.consCartProp-titulo {
    font-size: 18px;
    /* margin-left: 10px; */
}
.card-resultado-text {
    font-size: 15px;
}
.card-resultado-text-small {
    font-size: 14px;
}

.datatable-consCartProp {
    text-align: center;
}

}

@media (min-width:368px) {
.buscar-button-consulta {
    width: 60%;
}
.imagem-nenhuma-info {
    height: 10rem;
    width: auto;
}

}

@media (min-width:470px) {
.periodo-baixa-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.periodo-baixa-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-baixa-data { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.periodo-baixa-termino { grid-area: 1 / 3 / 2 / 4; }

.periodo-emissao-input {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: 100%;
  grid-column-gap: 4%;
}
.periodo-emissao-inicio { grid-area: 1 / 1 / 2 / 2; }
.periodo-emissao-data { grid-area: 1 / 2 / 2 / 3; align-self: center; }
.periodo-emissao-termino { grid-area: 1 / 3 / 2 / 4; }

}


@media (min-width:600px) {

.header-icons-consCartProp {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: 100%;
    grid-column-gap: 15px;
}

.buscar-button-header {
    display: block;
}
.buscar-button-consulta {
    display: none;
}

.imagem-nenhuma-info {
    height: 14rem;
    width: auto;
}

/* .consCartProp-titulo {
    margin-left: 20px;
} */
}

@media (min-width:801px) {
.consCartProp-titulo {
    font-size: 20px;
}

.consCartProp-conteudo {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(5, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 10px;
}

.filtro-unidade {  grid-area: 1 / 1 / 2 / 2; }
.filtro-cliente { grid-area: 1 / 2 / 2 / 3; }

.numero-solicitacao { grid-area: 2 / 1 / 3 / 2; }
.numero-cartaProp { grid-area: 2 / 2 / 3 / 3; }
.filtro-produto { grid-area: 3 / 1 / 4 / 2; }

.produto-novo {  grid-area: 3 / 2 / 4 / 3; }
.periodo-baixa { grid-area:  4 / 1 / 5 / 2; }
.periodo-emissao { grid-area: 4 / 2 / 5 / 3;}
.filtro-status { grid-area:5 / 1 / 6 / 2; }
.ordenacao { grid-area: 5 / 2 / 6 / 3; }
}

@media (min-width:1025px) {
.consCartProp-titulo {
    font-size: 22px;
}

.consCartProp-conteudo {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 10px;
}

.filtro-unidade { grid-area: 1 / 1 / 2 / 2; }
.filtro-cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitacao { grid-area: 1 / 3 / 2 / 4; }
.numero-cartaProp { grid-area: 2 / 1 / 3 / 2; }
.filtro-produto { grid-area: 2 / 2 / 3 / 3; }
.produto-novo { grid-area: 2 / 3 / 3 / 4; }
.filtro-status { grid-area: 3 / 1 / 4 / 2; }
.periodo-baixa { grid-area: 3 / 2 / 4 / 3;  }
.periodo-emissao { grid-area: 3 / 3 / 4 / 4; }
.ordenacao { grid-area: 4 / 1 / 5 / 2; }

.card-resultado-text {
    font-size: 16px;
}
.card-resultado-text-small {
    font-size: 14px;
}
.imagem-nenhuma-info {
    height: 16rem;
    width: auto;
}
}

@media (min-width:1281px) {

}

@media (min-width:1500px) {
.consCartProp-conteudo {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 10px;
}

.filtro-unidade { grid-area: 1 / 1 / 2 / 2;  }
.filtro-cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitacao { grid-area: 1 / 3 / 2 / 4; }
.numero-cartaProp { grid-area: 1 / 4 / 2 / 5; }
.filtro-produto { grid-area: 1 / 5 / 2 / 6; }

.produto-novo { grid-area: 2 / 1 / 3 / 2; }
.filtro-status { grid-area: 2 / 2 / 3 / 3; }
.periodo-baixa { grid-area: 2 / 3 / 3 / 4; }
.periodo-emissao { grid-area: 2 / 4 / 3 / 5; }
.ordenacao { grid-area: 2 / 5 / 3 / 6; }
}
</style>